<template>
    <div style="border-radius: 10px; background: #fff; padding: 10px">
        <div class="handle-box">
            时间：
            <el-date-picker
                v-model="dateTime"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @blur="getTime"
                @change="changeTime"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
            >
            </el-date-picker>
            列表：
            <el-select v-model="form.keyword" filterable clearable placeholder="请选择" class="handle-select mr10">
                <el-option v-for="(item, index) in allSelect.code" :key="index" :label="item.chinese" :value="item.code"></el-option>
            </el-select>
            操作：
            <el-select v-model="form.operate" filterable clearable placeholder="请选择" class="handle-select mr10">
                <el-option v-for="(item, index) in allSelect.operate" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            单号：
            <el-input v-model="form.user_no" placeholder="请输入内容" style="width: 200px"></el-input>
            <el-button type="primary" @click="searchIt" style="margin-left: 20px">{{ $t('common.confirm') }}</el-button>
        </div>
        <el-table :data="tableData" border stripe style="width: 100%">
            <el-table-column label="用户" prop="login_staff" align="center"></el-table-column>
            <el-table-column prop="use_no" label="编号" align="center"></el-table-column>
            <el-table-column prop="code" label="页面" align="center"></el-table-column>
            <el-table-column prop="operate" label="操作" align="center"></el-table-column>
            <el-table-column prop="date" label="日期" align="center"></el-table-column>
            <el-table-column prop="ip" label="IP" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="form.page"
                :page-size="form.page_size"
                :page-sizes="[30, 50, 100]"
                :total="pageTotal"
                @current-change="handlePageChange"
                @size-change="pageSizeChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { apiSystemLog, apiCurrentPermisson, apiSystemLogPull } from '@/request/api';
export default {
    data() {
        let self = this; // 加上这句改变this就可以了
        return {
            form: {},
            tableData: [],
            perData: '',
            pageIndex: 1,
            pageSize: 30,
            pageTotal: 0,
            dateTime: '',
            allSelect: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            if (self.tabPosition !== 'today') {
                                self.tabPosition = 'today'; // 设置tab位置为今天
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0); // 设置开始时间为今天的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为今天的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            if (self.tabPosition !== 'zuori') {
                                self.tabPosition = 'zuori'; // 设置tab位置为昨日
                            }
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24); // 设置为昨日的时间
                            start.setHours(0, 0, 0, 0); // 设置开始时间为昨日的00:00:00
                            end.setHours(23, 59, 59, 999); // 设置结束时间为昨日的23:59:59
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            if (self.tabPosition !== 'benyue') {
                                self.tabPosition = 'benyue'; // 设置tab位置为本月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            const start = new Date(currentYear, currentMonth, 1); // 本月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 本月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为本月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            if (self.tabPosition !== 'shangyue') {
                                self.tabPosition = 'shangyue'; // 设置tab位置为上月
                            }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();

                            // 如果当前月份是1月（即0月），则上个月是去年12月
                            if (currentMonth === 0) {
                                currentMonth = 11; // 上个月是12月
                                currentYear--; // 年份减1
                            } else {
                                currentMonth--; // 上个月
                            }
                            const start = new Date(currentYear, currentMonth, 1); // 上月第一天
                            const end = new Date(currentYear, currentMonth + 1, 0); // 上月最后一天
                            end.setHours(23, 59, 59, 999); // 设置结束时间为上月的最后一秒
                            self.dateTime = [start, end]; // 更新 dateTime
                            picker.$emit('pick', [start, end]); // 触发选中的日期范围
                        }
                    }
                ]
            }
        };
    },
    created() {
        // 获取当前日期
        const today = new Date();

        // 设置开始时间为今天的 00:00:00
        const start = new Date(today);
        start.setHours(0, 0, 0, 0);

        // 设置结束时间为今天的 23:59:59
        const end = new Date(today);
        end.setHours(23, 59, 59, 999);

        // 将设置的时间转换成字符串格式，如果需要
        const beginDate = this.formatDate(start);
        const endDate = this.formatDate(end);

        // 更新表单的开始和结束日期
        this.form.begin_date = beginDate;
        this.form.end_date = endDate;

        // 用于保存当前月份的日期范围
        const thisMonth = [beginDate, endDate];
        this.dateTime = thisMonth;

        this.geData();
        this.getPermission();
        this.getPull();
    },
    methods: {
        changeTime(val) {
            if (val == null) {
                this.$message.error('时间不能为空,已默认为当天');
                setTimeout(() => {
                    this.form.begin_date = this.formatDate(new Date());
                    this.form.end_date = this.formatDate(new Date());
                    const thisMonth = [];
                    thisMonth.push(this.form.begin_date, this.form.end_date);
                    this.dateTime = thisMonth;
                    this.geData();
                }, 500);
            } else {
                this.tabPosition = '';
            }
        },
        getTime(event) {
            this.form.begin_date = event.displayValue[0];
            this.form.end_date = event.displayValue[1];
        },
        formatDate(date) {
            const pad = (num) => num.toString().padStart(2, '0'); // 补零函数
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // 返回带时分秒的完整时间
        },
        searchIt() {
            this.form.page = 1;
            this.form.page_size = 10;
            // console.log(this.form, 'this.form');
            this.geData();
        },
        // 获取页面信息-----------------------------------------
        geData() {
            this.$load.show();
            apiSystemLog({
                ...this.form
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '52'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取下拉
        getPull() {
            apiSystemLogPull({}).then((res) => {
                if (res.code == 2000) {
                    //
                    this.allSelect = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.form.page = val;
            this.geData();
        },
        pageSizeChange(val) {
            //
            this.form.page_size = val;
            this.geData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}
.handle-select {
    width: 200px;
}
.handle-input {
    width: 300px;
    display: inline-block;
}
.mr10 {
    margin-right: 10px;
}
</style>
